module.exports = __webpack_public_path__ + "static/media/location-circle.f6fd4e03.svg";